module.exports = __webpack_public_path__ + "img/snowflake.cab4151b.png";